import api from '@/api'

export default {
    namespaced: true,
    state: {},
    actions: {
        /**
         * NOTE: 申請加入頻道
         * @return {Object}
         */
        async applyChannel(context, schoolCode) {
            return new Promise(function(resolve) {
                api.sokplatformApi.applyChannel(schoolCode).then(() => {
                    resolve(true)
                }).catch(() => {
                    resolve(true)
                })
            })
        }
    }
}
